// extracted by mini-css-extract-plugin
module.exports = {"text_center":"s_text_center__3EWL8","table":"s_table__3btA5","red":"s_red___B5lJ"};